import $ from 'jquery';

if( $( '.gform_wrapper' ).length ) {
  
  // Check against a honeypot
  $( 'form' ).on( 'submit', function() {
    let val = document.getElementById('emails').value
    
    if( val !== '' ){
      console.log('gotcha')
      window.dataLayer.push( {'event': 'spam', 'value': 'spam caught' } );
      alert( 'Please insure you have completed the math problem underneath the "Message" window. This browser has detected you to be a bot, and is unable to send the form. If this is incorrect please reach out to Brewsters another way, or resend the form.' );
      return false;
    }
  })
}